import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import DictsInfo from '../../components/dicts_info.jsx'



function refreshPage(){
  setTimeout(()=>{
    window.location.reload(false);
  }, 500);
 
}

export default class MainCorelDraw extends Component {
  render() {
    return (
      <div style={{backgroundColor: '#9fd9ff'}}>

        <title>Tutorial Lengkap Corel Draw X6</title>

        <section className="colorlib-experience" data-section="timeline">
          <div className="colorlib-narrow-content">
            <div className="row" style={{backgroundColor: '#9fd9ff'}}>

              <div className="col-md-9 col-md-offset-0 col-md-pull-0" >

                {/* <br/>
                <br/>                 */}
                {/* <h2 className="colorlib-heading animate-box"> */}
                <h1 className="colorlib-heading">
                Tutorial Lengkap Corel Draw X6
                </h1>             
              

            <div className="row" style={{backgroundColor: '#9fd9ff'}}>
              <div className="col-md-12 col-md-offset-0 col-md-pull-0">
                <div className="timeline-centered">
                

                  {/* <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft"> */}
                  <article className="timeline-entry">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-3">
                        <i className="icon-pen2" />
                      </div>                      

                      <div className="timeline-label">
                        <h2>
                          #1
                          <br/>
                          Apa itu Corel Draw
                      </h2>
                      <Link to="/corel-draw/apa-itu-corel-draw" className="nav-link" onClick={refreshPage}>
                      <p>Read more...</p>
                      </Link>
                      </div>
                    </div>
                  </article>

                  {/* <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft"> */}
                  <article className="timeline-entry">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-4">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          #2
                          <br/>
                          Instal Corel Draw X6
                        </h2>
                        <Link to="/corel-draw/install-corel-draw-x6" className="nav-link" onClick={refreshPage}>
                        <p>Read more...</p>
                        </Link>
                      </div>
                    </div>
                  </article>

                  {/* <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft"> */}
                  <article className="timeline-entry">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-4">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          #3
                          <br/>
                          Mengenal Bagian Bagian Corel Draw X6
                        </h2>
                        <Link to="/corel-draw/mengenal-bagian-bagian-corel-draw-x6" className="nav-link" onClick={refreshPage}>
                        <p>Read more...</p>
                        </Link>
                      </div>
                    </div>
                  </article>

                   {/* <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft"> */}
                   <article className="timeline-entry">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-4">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          #4
                          <br/>
                          Merubah Bahasa Corel Draw X6
                        </h2>
                        <Link to="/corel-draw/merubah-bahasa-corel-draw-x6" className="nav-link" onClick={refreshPage}>
                        <p>Read more...</p>
                        </Link>
                      </div>
                    </div>
                  </article>

                  {/* <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft"> */}
                  <article className="timeline-entry">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-4">
                        <i className="icon-pen2" />
                      </div>
                      <div className="timeline-label">
                        <h2>
                          #5
                          <br/>
                          Mengubah pengaturan Startup Corel Draw X6
                        </h2>
                        <Link to="/corel-draw/mengubah-pengaturan-startup-corel-draw-x6" className="nav-link" onClick={refreshPage}>
                        <p>Read more...</p>
                        </Link>
                      </div>
                    </div>
                  </article>

                  {/* <article className="timeline-entry animate-box" data-animate-effect="fadeInLeft"> */}
                  <article className="timeline-entry">
                    <div className="timeline-entry-inner">
                      <div className="timeline-icon color-none">
                      </div>
                    </div>
                  </article>
                </div>
              </div>
              </div>              
            </div>
              <DictsInfo/>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
